module.exports = __webpack_public_path__ + "static/media/MEGHNA-GUJARATHI.fe4c99a3.png";